module.exports = __webpack_public_path__ + "3386505b9d884ddc1bb154026febcc05.arrow-desktop.svg";